import { createSlice } from '@reduxjs/toolkit';

import { apiConnector } from '../integrations/api.connector';
import { createAsyncThunk } from './create-async-thunk';

export const getClientById = createAsyncThunk(
  'clients/getClientById',
  async (id: string) => {
    return apiConnector.getClientById(id);
  }
);

export const getClientByIin = createAsyncThunk(
  'clients/getClientByIin',
  async (data: { iin: string; abortSignal?: AbortSignal }) => {
    return apiConnector.getClientByIin(data.iin, data.abortSignal);
  }
);

export const clientsSlice = createSlice({
  name: 'clients',
  initialState: null,
  reducers: {}
});
